<template>
  <div class="carousel-novelty">
    <div class="row no-gutters swiper-wrap">
      <Swiper
        id="news-carousel"
        class="row no-gutters w-100 flex-grow-1 h-auto list-unstyled overflow-visible"
        effect="coverflow"
        :grab-cursor="true"
        :centered-slides="true"
        :autoplay="{ delay: 6000, disableOnInteraction: false }"
        :loop="true"
        slides-per-view="auto"
        :coverflow-effect="{
          rotate: 0,
          stretch: 200,
          depth: 300,
          modifier: 1,
          slideShadows: true,
        }"
        :pagination="true"
        :modules="modules"
        @swiper="onSwiper"
        @slide-change="onSlideChange"
      >
        <SwiperSlide
          v-for="item in news"
          :key="item.id"
          class="col-12 flex flex-col pr-0 pl-0"
        >
          <div class="slide-inner">
            <a :href="item.link">
              <div class="novelty__image mb-3 lg:mb-0">
                <div class="embed-responsive overflow-hidden image-rounded">
                  <RemoteResponsiveImage
                    :product-image-data="item.image"
                    img-class="embed-responsive-item relative image-cover"
                    :alt="item.title"
                    sizes="(min-width: 1200px) 620px, (min-width: 768px) 25vw, (min-width: 600px) 35vw, (min-width: 500px) 50vw, 70vw"
                    :placeholder="true"
                    placeholder-class="mt-n4"
                    placeholder-height="74"
                  />
                </div>
              </div>
            </a>
            <div class="swiper-slide-text text-center pt-2 lg:pt-4">
              <h2 class="h2 mb-2 lg:mb-4 w-100">
                {{ item.title }}
              </h2>
              <p
                class="mb-3 text-sm relative text-wide"
                v-html="item.text"
              />
              <a
                :href="item.link"
                class="btn btn-success  px-4 lg:px-5 xl:px-6 py-3 mt-auto stretched-link rounded-pill"
              >
                {{ t('want_to_taste') }}
              </a>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <!-- Carousel arrows -->
      <ButtonChevron
        direction="l"
        class="btn-warning text-primary p-3 lg:p-4 rounded-circle btn-prev"
        data-slide="prev"
        aria-label="Previous slide"
        @click="prevSlide"
      />
      <ButtonChevron
        direction="r"
        class="btn-warning text-primary p-3 lg:p-4 ml-2 lg:ml-4 rounded-circle btn-next"
        data-slide="next"
        aria-label="Next slide"
        @click="nextSlide"
      />
    </div>
  </div>
</template>

<script setup>
import { Autoplay, EffectCoverflow, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import ButtonChevron from '@/components/buttons/ButtonChevron.vue'
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'

const modules = [EffectCoverflow, Pagination, Navigation, Autoplay]

defineProps({
  news: {
    type: Array,
    default: () => [],
  },
})

const { t } = useI18n()

const activeNavigationIndex = ref(0)
const swiperNewsInstance = ref()

const onSwiper = (swiper) => {
  swiperNewsInstance.value = swiper
}

const prevSlide = () => {
  if (swiperNewsInstance.value) swiperNewsInstance.value.slidePrev()
}

const nextSlide = () => {
  if (swiperNewsInstance.value) swiperNewsInstance.value.slideNext()
}

const onSlideChange = () => {
  if (swiperNewsInstance.value) activeNavigationIndex.value = swiperNewsInstance.value.realIndex
}
</script>

<i18n>
  {
    "cs": {
    "want_to_taste": "Chci ochutnat"
},
    "sk": {
    "want_to_taste": "Chcem ochutnať"
},
    "pl": {
    "want_to_taste": "Spróbuj"
},
    "hu": {
    "want_to_taste": "Megkóstolom"
},
    "de": {
    "want_to_taste": "Jetzt probieren!"
},
    "at": {
    "want_to_taste": "Jetzt probieren!"
},
    "ro": {
    "want_to_taste": "Vreau să gust"
}
  }
</i18n>
